import React from 'react';
import {
  Paper,
  Typography,
  Grid,
  Box
} from '@mui/material';
import { People } from '@mui/icons-material';

const UserSummaryCard = ({ userSummary }) => {
  if (userSummary.totalUsers === 0) {
    return null;
  }

  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <People color="primary" />
        User Summary
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <Box sx={{ p: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
            <Typography variant="body2" color="textSecondary">Total Users</Typography>
            <Typography variant="h5">{userSummary.totalUsers}</Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Box sx={{ p: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
            <Typography variant="body2" color="textSecondary">Active Users</Typography>
            <Typography variant="h5">{userSummary.activeUsers}</Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Box sx={{ p: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
            <Typography variant="body2" color="textSecondary">Total Roles in Use</Typography>
            <Typography variant="h5">{userSummary.totalRoles}</Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Box sx={{ p: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
            <Typography variant="body2" color="textSecondary">Users by Role</Typography>
            <Box sx={{ mt: 1, maxHeight: '150px', overflowY: 'auto' }}>
              {Object.entries(userSummary.usersByRole).map(([role, count]) => (
                <Typography key={role} variant="caption" display="block">
                  {role}: {count}
                </Typography>
              ))}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default UserSummaryCard;

